import React, { useState, useEffect, useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { DatePicker, Table, Pagination, Select, Card, Button } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import generatePDF from "react-to-pdf";
import { useSelector, useDispatch } from "react-redux";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import { socket } from "../../socket";
import moment from "moment";
import { updateFilter } from "../../store/features/Filters/transactionSlice";

const Transactions = () => {
  const dispatch = useDispatch();
  const transactionFilterDetails = useSelector(
    (state) => state.transactionFilter.list
  );
  const [pageDetails, setPageDetails] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(1);
  const [orderCount, setOrderCount] = useState(0);
  const [userDetails, setUserDetails] = useState();
  const [order, setOrder] = useState();
  const [shop, setShop] = useState();
  const [date, setDate] = useState();
  const [status, setStatus] = useState();
  const [shopesList, setShopsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  let navigate = useNavigate();
  const targetRef = useRef();
  const dateFormat = "YYYY/MM/DD";

  let roleId = Helper.UserRole();

  const columns = [
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (createdAt) => moment(createdAt).format("DD-MM-YYYY, h:mm:ss a"),
    },
    {
      title: "Product",
      dataIndex: "BillingOrder",
      render: (BillingOrder) => BillingOrder?.Category?.name,
    },
    {
      title: "Order ID",
      dataIndex: "BillingOrder",
      render: (BillingOrder) => BillingOrder?.orderId,
    },
    {
      title: "User",
      dataIndex: "user",
      render: (user) => user.name,
    },
    {
      title: "Amount",
      dataIndex: "amount",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Balance",
      dataIndex: "BillingOrder",
      render: (text, record) => {
        return (
          <>
            {record?.reamingAmount == 0 && record?.currentBalance == 0 ? (
              <>-</>
            ) : (
              <>
                <span className="text-success">₹{record?.reamingAmount}</span>
                <br />
                <span className="text-danger">
                  <s>₹{record?.currentBalance}</s>
                </span>
              </>
            )}
          </>
        );
      },
    },
    {
      title: "Points",
      dataIndex: "BillingOrder",
      render: (BillingOrder) => BillingOrder?.points,
    },
    {
      title: "Used Points",
      dataIndex: "BillingOrder",
      render: (BillingOrder) => BillingOrder?.totalDiscountAmount,
    },
    {
      title: "Notes",
      dataIndex: "notes",
    },
  ];

  useEffect(() => {
    try {
      (async () => {
        setLoading(true);
        const data = await axios
          .get("/transaction-list", {
            params: {
              roleId,
              limit,
              page,
              status: transactionFilterDetails.status,
              date: transactionFilterDetails.date,
              shop: transactionFilterDetails.shop,
              order: transactionFilterDetails.order,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) {
          setPageDetails(data.data.data);
          setCount(data.data.count);
          setUserDetails(data.data.userDetails);
          setOrderCount(data.data.orderCount);
          setLoading(false);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, [
    limit,
    page,
    transactionFilterDetails.shop,
    transactionFilterDetails.status,
    transactionFilterDetails.date,
    transactionFilterDetails.order,
  ]);

  useEffect(() => {
    try {
      (async () => {
        const shopDetails = await axios
          .get("/all-shops", {
            params: {
              roleId,
            },
          })
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (shopDetails && shopDetails.data) {
          setShopsList(shopDetails.data.data);
        }
      })();
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  }, []);

  const handleChange = (value) => {
    setPage(1);
    setLimit(value);
  };

  function onSelectDate(date, dateString) {
    if (dateString[0]) {
      setDate(dateString);
      dispatch(updateFilter({ date: dateString }));
    } else {
      dispatch(updateFilter({ date: "" }));
    }
  }

  return (
    <Container fluid>
      <div className="order-pg">
        <Row>
          {roleId == 3 && (
            <Col lg={12} className="dashboard-cards">
              <Col md={4} xs={12}>
                <Card title="Orders" bordered={false} className="cards-details">
                  {orderCount}
                </Card>
              </Col>
              <Col md={4} xs={12}>
                <Card
                  title="Pending Amount"
                  bordered={false}
                  className="cards-details pending"
                >
                  {userDetails?.pendingAmount}
                </Card>
              </Col>
              <Col md={4} xs={12}>
                <Card
                  title="Total Points"
                  bordered={false}
                  className="cards-details points"
                >
                  {userDetails?.points}
                </Card>
              </Col>
            </Col>
          )}
          <Col lg={12}>
            <div className="new-order-btn">
              <Button
                danger
                onClick={() =>
                  generatePDF(targetRef, { filename: "transaction.pdf" })
                }
              >
                PDF
              </Button>
              <Button
                type="primary"
                ghost
                className="ms-2"
                onClick={() =>
                  window.open(
                    "http://thecharmingtreasure.in:4000/uploads/TCT_Price_List.pdf"
                  )
                }
              >
                Price List
              </Button>
            </div>
          </Col>
          <Col lg={12}>
            <div className="order-pg-cards mt-2">
              <div className="input-group search">
                <input
                  type="text"
                  className="form-control search-input-box"
                  placeholder="Search by order"
                  value={transactionFilterDetails.order}
                  onChange={(e) => {
                    dispatch(updateFilter({ order: e.target.value }));
                  }}
                />
                <FontAwesomeIcon
                  className="search-fn"
                  icon={faMagnifyingGlass}
                />
              </div>
              <div className="input-group search">
                <Select
                  defaultValue="All"
                  style={{ width: "96%", height: "100%" }}
                  onChange={(input) =>
                    dispatch(updateFilter({ status: input }))
                  }
                  value={transactionFilterDetails.status}
                  options={[
                    { value: "", label: "All" },
                    { value: "credit", label: "Credit" },
                    { value: "debit", label: "Debit" },
                  ]}
                />
              </div>
              {roleId != 3 && (
                <div className="input-group search">
                  <Select
                    showSearch
                    defaultValue="All"
                    style={{ width: "96%", height: "100%" }}
                    optionFilterProp="children"
                    value={transactionFilterDetails.shop}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={(input) =>
                      dispatch(updateFilter({ shop: input }))
                    }
                  >
                    <Option key={0} value={""}>
                      Select
                    </Option>
                    {shopesList.map((i) => (
                      <Option key={i.id} value={i.id}>
                        {i.name}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}
              {roleId == 1 || roleId == 3 ? (
                <div className="input-group search">
                  <RangePicker
                    onChange={onSelectDate}
                    defaultValue={
                      transactionFilterDetails.date && [
                        dayjs(transactionFilterDetails.date[0], dateFormat),
                        dayjs(transactionFilterDetails.date[1], dateFormat),
                      ]
                    }
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </Col>
          <Col md={12}>
            <div className="orders-list">
              <Table
                columns={columns}
                dataSource={pageDetails}
                pagination={false}
                rowKey="id"
                ref={targetRef}
                loading={loading}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      if (record.orderId) {
                        navigate(`/orderdetails/${record.orderId}`);
                      }
                    },
                  };
                }}
              />
              <div className="pagination">
                <Select
                  defaultValue={limit}
                  style={{ width: 120 }}
                  onChange={handleChange}
                  options={[
                    {
                      value: 5,
                      label: "5",
                    },
                    {
                      value: 10,
                      label: "10",
                    },
                    {
                      value: 20,
                      label: "20",
                    },
                    {
                      value: 50,
                      label: "50",
                    },
                    {
                      value: 100,
                      label: "100",
                    },
                  ]}
                />
                {loading === false && (
                  <Pagination
                    defaultCurrent={page}
                    pageSize={limit}
                    showSizeChanger={false}
                    total={count}
                    onChange={setPage}
                  />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Transactions;
